import { Banco } from './banco';
import { FormaPago } from './forma-pago';

export class Cheque{
    public constructor(
        public forma_pago_id: String = "2",
        public fecha: String = "",
        public cuenta: String = "",
        public numero: String = "",
        public valor: number = 0,
        public observacion: String = "",
        public banco_id: String = "",

        public banco: Banco = new Banco(),
        public forma_pago: Banco = new FormaPago(),
    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/cheque.ts